export default __webpack_public_path__ + "static/media/sessions_tg_bot_ru.c9ed03b3.jpg";